<template>
  <article class="cmp cmp-product-thumb" :data-testing="item.variation.id">
    <div :class="paddingClasses" :style="paddingInlineStyles">
      <div class="thumb-image">
        <div class="prop-1-1">
          <slot name="item-image">
            <category-image-carousel
              :image-urls-data="item.images | itemImages(imageUrlAccessor)"
              :alt="item | itemName"
              :title="item | itemName"
              :item-url="item | itemURL(urlWithVariationId)"
              :enable-carousel="$ceres.config.item.enableImageCarousel"
              :disable-carousel-on-mobile="disableCarouselOnMobile"
              ref="categoryImageCarousel"
            >
            </category-image-carousel>
          </slot>
          <div class="wish-wrapper">
            <add-to-wish-list :variation-id="item.variation.id"></add-to-wish-list>
          </div>
          <div class="tag" v-if="tagName && !isClosed()">
            <span class="badge bg-danger">{{ tagName }}</span>
          </div>
        </div>
        <div class="closed" v-if="isClosed()">
          <a :href="item | itemURL(urlWithVariationId)" class="message">
            <span><i class="fa fa-lock mr-1" aria-hidden="true"></i>Gerücht geschlossen</span>
          </a>
        </div>

        <p v-if="badge && sales() && !isClosed()" class="sales-badge mb-0">
          <span :class="'badge badge-' + badge.color" v-html="badge.text"></span>
        </p>
        <p v-if="!hasProperty82()" class="ki-info mb-0">
          <span class="badge"><i class="fa fa-info-circle mr-1" aria-hidden="true"></i>{{ $translate("FanLiebling::Singleitem.KIImage") }}</span>
        </p>
      </div>
      <!-- STORE SPECIALS -->
      <slot name="store-special">
        <item-store-special
          v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
          :store-special="storeSpecial"
          :recommended-retail-price="item.prices.rrp"
          :variation-retail-price="item.prices.default"
          :special-offer-price="item.prices.specialOffer"
          :decimal-count="decimalCount"
          :bundle-type="item.variation.bundleType"
          :item-type="item.item.itemType"
        >
        </item-store-special>
      </slot>
      <!-- ./STORE SPECIALS -->

      <!-- ITEM DETAILS -->
      <slot name="item-details">
        <div class="thumb-content">
          <div class="d-flex justify-content-between align-items-start">
            <a :href="item | itemURL(urlWithVariationId)" class="thumb-title">
              {{ item | itemName }}
            </a>
            <div v-if="probability()" class="probability mb-0 position-relative" @mouseover="showTooltip = true" @mouseleave="showTooltip = false">
              <div v-if="showTooltip" class="custom-tooltip">Unsere Einschätzung</div>
              <span class="content">
                <template v-if="probability() !== false">
                  <i class="fa fa-handshake-o" aria-hidden="true"></i>
                  <span v-if="probability() === '?'">{{ probability() }}</span>
                  <span v-else>{{ probability() }}%</span>
                </template>
                <template v-if="progression() !== false">
                  <i
                    :class="{
                      'fa text-danger fa-angle-double-down': progression() === 'Fallend',
                      'fa text-success fa-angle-double-up': progression() === 'Steigend',
                    }"
                    aria-hidden="true"
                  ></i>
                </template>
              </span>
            </div>
          </div>

          <div class="thumb-meta">
            <div class="rumor-wrapper my-2">
              <div class="clubs d-flex justify-content-between align-items-center" v-if="fromClub() && toClub()">
                <span class="font-weight-bold"><slot name="from-club-name"></slot></span>
                <i class="fa fa-long-arrow-right arrow mx-3" aria-hidden="true"></i>
                <span class="font-weight-bold"><slot name="to-club-name"></slot></span>
              </div>

              <div class="w-100 justify-content-between marketValue d-none" v-if="marketValue()">
                <span>{{ marketValue() }}€</span>
              </div>
            </div>
            <slot name="before-prices"></slot>
          </div>

          <!-- Progressbar und Info nur in die DOM, wenn du sie wirklich anzeigen willst -->
          <div v-if="false" class="progress-bar-container position-relative border-radius mt-2" @mouseover="showTooltip = true" @mouseleave="showTooltip = false">
            <div class="progress-bar border-radius" :style="{ width: progressWidth + '%' }"></div>
          </div>
          <div v-if="false" class="w-100 flex-wrap align-items-center progress-info-left mb-4">
            <div class="progress-info-border" :style="{ width: progressWidth + '%' }"></div>
            <span class="pl-2 small">{{ $translate("FanLiebling::Singleitem.progressReached") }}</span>
          </div>

          <a :href="item | itemURL(urlWithVariationId)" class="btn btn-block btn-primary btn-appearance font-weight-bold border-radius">
            <i class="fa fa-arrow-right mr-1" aria-hidden="true"></i>
            <span>Zu deinem Liebling!</span>
          </a>

          <slot name="after-prices"></slot>
        </div>
      </slot>
      <!-- ./ITEM DETAILS  -->
    </div>
  </article>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";
import { getSlotData } from "../../helper/getSlotData";

export default {
  components: {
    CategoryImageCarousel,
    ItemStoreSpecial,
  },

  props: {
    decimalCount: {
      type: Number,
      default: 0,
    },
    imageUrlAccessor: {
      type: String,
      default: "urlMiddle",
    },
    itemData: {
      type: Object,
    },
    disableCarouselOnMobile: {
      type: Boolean,
    },
    paddingClasses: {
      type: String,
      default: null,
    },
    paddingInlineStyles: {
      type: String,
      default: null,
    },
    forceUrlWithVariationId: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      maxValue: 1,
      currentValue: 0,
      showTooltip: false,
      targetValue: 0,
      progressWidth: 0,
    };
  },

  jsonDataFields: ["itemDataRef"],

  computed: {
    item() {
      return this.itemData || this.itemSlotData || this.itemDataRef;
    },

    itemSlotData: getSlotData("item-data"),

    // procent() {
    //   const numericMaxValue = this.maxValue || 1;
    //   const numericCurrentValue = this.currentValue || 0;

    //   if (numericMaxValue === 0) return 0; // Verhindert Division durch 0

    //   const percentValue = (numericCurrentValue / numericMaxValue) * 100;
    //   return percentValue;
    // },

    /**
     * returns itemData.item.storeSpecial
     */
    storeSpecial() {
      return this.item.item.storeSpecial;
    },

    badge() {
      const sales = this.sales();
      if (!sales) return null;

      if (sales >= 5 && sales < 10) {
        return { text: "<i class='fa fa-rocket'></i> Dein Support zählt!", color: "secondary" };
      } else if (sales >= 10 && sales < 20) {
        return { text: "<i class='fa fa-fire'></i> Beliebt", color: "warning" };
      } else if (sales >= 20 && sales <= 30) {
        return { text: "<i class='fa fa-star'></i> Sehr gefragt", color: "info" };
      } else if (sales > 30) {
        return { text: "<i class='fa fa-trophy'></i> Bestseller", color: "success" };
      }
    },

    /**
     * returns itemData.texts
     */
    texts() {
      return this.item.texts;
    },

    tagName() {
      const tag = this.item.tags?.[0];
      return tag?.id === 1 ? tag?.names?.name || null : null;
    },

    itemPrice() {
      return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
    },

    basePrice() {
      return this.item.prices.default.basePrice;
    },

    itemPriceGraduated() {
      let unitPrice;
      if (App.config.item.enableGraduatedPrices) {
        unitPrice = this.item.prices.graduatedPrices.length > 0 ? this.item.prices.graduatedPrices[0].unitPrice : this.item.prices.default.unitPrice;
      } else {
        unitPrice = this.item.prices.default.unitPrice;
      }

      return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
    },

    itemGraduatedPriceisCheapestSorting() {
      return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
    },

    itemGraduatedPricesalableVariationCount() {
      return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
    },

    itemSetPrice() {
      return this.$options.filters.currency(this.item.prices.default.price.value, this.item.prices.default.currency);
    },

    urlWithVariationId() {
      return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
    },

    hasCrossPrice() {
      const hasRrpPrice = !!this.item.prices.rrp && this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

      const hasBeforePrice = !!this.item.prices.specialOffer && !!this.item.prices.default && this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

      return hasRrpPrice || hasBeforePrice;
    },

    ...mapState({
      showNetPrices: (state) => state.basket.showNetPrices,
    }),
  },

  mounted() {
    // Werte holen und sicherstellen, dass sie numerisch sind
    const marketValueRaw = this.marketValue();
    const remainingStockRaw = this.remainingStock();

    const marketValueInt = parseInt(marketValueRaw.replace(/\D/g, ""), 10) || 1;
    const remainingStock = parseInt(remainingStockRaw.replace(/\D/g, ""), 10) || 0;

    // Zielwert basierend auf dem Marktwert festlegen
    let targetValue;
    if (marketValueInt <= 2000000) {
      targetValue = 800000;
    } else if (marketValueInt <= 10000000) {
      targetValue = 1500000;
    } else {
      targetValue = 5000000;
    }

    // Fortschrittsbreite berechnen
    const consumedValue = marketValueInt - remainingStock;
    this.progressWidth = ((consumedValue / (marketValueInt - targetValue)) * 100).toFixed(2);
  },

  methods: {
    sales() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 77);
            if (result?.values) {
              const value = parseInt(result.values.value, 10); // <<< String zu Integer
              return isNaN(value) ? false : value; // Falls parseInt fehlschlägt, gib false zurück
            }
          }
        }
      }
      return false;
    },
    probability() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 63);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },
    progression() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 64);
            if (result?.values) {
              const value = result.values.value;
              // Rückgabe der entsprechenden Werte
              if (value === "-1") {
                return "Fallend";
              } else if (value === "1") {
                return "Steigend";
              }

              return false; // Rückgabe false für nicht erkannte Werte
            }
          }
        }
      }
      return false; // Rückgabe false, falls keine Werte gefunden werden
    },
    isClosed() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 62);
            if (result?.values && typeof result.values.value === "string" && result.values.value.trim() !== "") {
              return true;
            }
          }
        }
      }
      return false;
    },
    fromClub() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 61);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },
    toClub() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 60);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },
    marketValue() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 58);
            if (result?.values) {
              const value = Number(result.values.value); // Stelle sicher, dass es eine Zahl ist

              return value.toLocaleString("de-DE");
            }
          }
        }
      }
      return "1";
    },

    remainingStock() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 74);
            if (result?.values) {
              return result.values.value || "0";
            }
          }
        }
      }
      return "0";
    },

    hasProperty82() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 82);
            if (result) {
              return true; // Eigenschaft ID 82 ist vorhanden
            }
          }
        }
      }
      return false; // Eigenschaft ID 82 ist nicht vorhanden
    },
  },
};
</script>
